import { API_BASE_URL } from '@/integrations/api/config';
import { getAccessToken } from '@/integrations/api/token_storage';

/** Minimal surface used by notification / invitation hooks. */
export type TransmitSubscription = {
  create: () => Promise<void>;
  delete: () => Promise<void>;
  onMessage: (handler: () => void) => void;
};

export type TransmitClient = {
  subscription: (channel: string) => TransmitSubscription;
};

let transmit: TransmitClient | null = null;
let loadPromise: Promise<TransmitClient | null> | null = null;

async function loadTransmitClient(): Promise<TransmitClient | null> {
  if (!API_BASE_URL) return null;
  if (transmit) return transmit;

  try {
    const { Transmit } = await import('@adonisjs/transmit-client');
    transmit = new Transmit({
      baseUrl: API_BASE_URL,
      beforeSubscribe: (request) => {
        const token = getAccessToken();
        if (token) request.headers.set('Authorization', `Bearer ${token}`);
      },
      beforeUnsubscribe: (request) => {
        const token = getAccessToken();
        if (token) request.headers.set('Authorization', `Bearer ${token}`);
      },
    }) as TransmitClient;
    return transmit;
  } catch (err) {
    console.warn(
      '[transmit] Realtime desactivado — instala @adonisjs/transmit-client (npm i --legacy-peer-deps).',
      err,
    );
    return null;
  }
}

/** Lazy-loads Transmit so a missing npm package does not blank the whole app. */
export async function getTransmitClient(): Promise<TransmitClient | null> {
  if (!API_BASE_URL) return null;
  if (transmit) return transmit;
  loadPromise ??= loadTransmitClient();
  return loadPromise;
}
